(function(){
    var request = null;
    var timeout = null;

    if (!document.querySelector('.header-search-form')) {
        return false;
    }

    document.body.addEventListener('keyup', function (event) {
        if (event.target.matches('.header-search-form input')) {
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter') {
                var results = document.querySelector('.header-search-results');
                var selected = results.querySelector('.selected');

                if (!results.querySelector('li')) {
                    return false;
                }

                if (event.key === 'ArrowDown') {
                    if (selected) {
                        selected.classList.remove('selected');
                        if (!selected.nextElementSibling) {
                            results.querySelector('li:first-child').classList.add('selected');
                        } else {
                            selected.nextElementSibling.classList.add('selected');
                        }
                    } else {
                        results.querySelector('li:first-child').classList.add('selected');
                    }
                }

                if (event.key === 'ArrowUp') {
                    if (selected) {
                        selected.classList.remove('selected');
                        if (!selected.previousElementSibling) {

                        } else {
                            selected.previousElementSibling.classList.add('selected');
                        }
                    } else {
                        results.querySelector('li:last-child').classList.add('selected');
                    }
                }

                if (event.key === 'Enter') {
                    if (selected) {
                        return true;
                    }
                }

                selected = results.querySelector('.selected');
                if (selected) {
                    selected.scrollIntoView({block: "end"});
                }

                return false;

            } else {
                doDelayedSearch(event.target.value);
            }
        }
    });

    document.body.addEventListener('paste', function (event) {
        if (event.target.matches('.header-search-form input')) {
            doDelayedSearch(event.target.value);
        }
    });

    document.querySelector('.header-search-form input').addEventListener('focus', function (event) {
        if (event.target.matches('.header-search-form input')) {
            doDelayedSearch(event.target.value);
            document.body.classList.add('header-search-active');
        }
    });

    document.body.addEventListener('submit', function (event) {
        if (event.target.matches('.header-search-form')) {
            var results = document.querySelector('.header-search-results');
            var selected = results.querySelector('.selected');
            if (selected) {
                event.preventDefault();
                var url = selected.querySelector('a').getAttribute('href');
                console.log(url);
                window.location.href = url;
                return false;
            }
        }
    });

    document.addEventListener('keyup', function (e) {
        if (e.key === "Escape") {
            cancelSearch();
        }
    });

    document.body.addEventListener('click', function (e) {
        if (!e.target.closest('.header-search')) {
            cancelSearch();
        }
    });

    document.body.addEventListener('click', function (e) {
        if (e.target.closest('.btn-close-search')) {
            var form = document.querySelector('.header-search-form');
            document.body.classList.remove('header-search-active');
            form.parentNode.classList.remove('active');
        }
    });

    document.body.addEventListener('click', function (e) {
        if (e.target.closest('.btn-clear-search')) {
            var input = document.querySelector('.header-search-form input');
            input.value = '';
            input.focus();
        }
    });

    var doDelayedSearch = function(val) {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function() {
            doSearch(val);
        }, 100);
    }

    var doSearch = function (val) {
        var form = document.querySelector('.header-search-form');
        var url = form.dataset.results;
        var results = form.nextElementSibling;
        var request;

        val = val.trim();

        if (val.length < 2) {
            results.innerHTML = '';
            cancelSearch();
            return false;
        }

        if (request) {
            request.abort();
        }

        form.classList.add('loading');

        request = new XMLHttpRequest();
        request.open("POST", url, true);
        request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                results.innerHTML = request.responseText;
                form.classList.remove('loading');
                form.parentNode.classList.add('active');
            } else {
                form.classList.remove('loading');
            }
        };

        request.onerror = function () {
            form.classList.remove('loading');
        };

        request.send("query=" + encodeURIComponent(val));
    };

    var cancelSearch = function() {
        document.querySelector('.header-search').classList.remove('active');
        document.querySelector('.header-search-form').classList.remove('loading');

        if (request) {
            request.abort();
        }
        if (timeout) {
            clearTimeout(timeout);
        }
    }
})();